export default __webpack_public_path__ + "static/media/img12.61086ca1.png";